import {useSearchParams, SetURLSearchParams} from 'react-router'

import {SideCardItemMode, ViewMode} from '../types'

function urlParamsToViewMode(params: URLSearchParams): ViewMode {
  const eventId = params.has('eventId') ? params.get('eventId') : undefined
  const mode = params.has('mode') ? params.get('mode') : undefined

  switch (mode) {
    case undefined:
      if (eventId) return {mode: SideCardItemMode.Details, itemId: eventId} as ViewMode
      else return {mode: 'tableOnlyMode'} as ViewMode

    case SideCardItemMode.EditSingle:
    case SideCardItemMode.EditSeries:
    case SideCardItemMode.Details:
      if (!eventId) throw new Error('Event Id must be given with mode')
      return {mode, itemId: eventId}
    case SideCardItemMode.Create:
      return {mode}
    default:
      throw new Error('Unknown mode given in URL')
  }
}

export function viewModeToUrlParams(viewMode: ViewMode) {
  const params = new URLSearchParams()

  switch (viewMode.mode) {
    case SideCardItemMode.TableOnly:
      return params
    case SideCardItemMode.EditSingle:
    case SideCardItemMode.EditSeries:
    case SideCardItemMode.Details:
      params.append('mode', viewMode.mode)
      params.append('eventId', viewMode.itemId.toString())
      viewMode.taskPlantId && params.append('taskPlantId', viewMode.taskPlantId)
      viewMode.source && params.append('source', viewMode.source)
      viewMode.externalId && params.append('externalId', viewMode.externalId)
      return params
    case SideCardItemMode.Create:
      params.append('mode', SideCardItemMode.Create)
      return params
    default:
      throw new Error('Unknown mode')
  }
}

export const useQueryParameterForViewMode = (): ViewMode => {
  const [params]: [URLSearchParams, SetURLSearchParams] = useSearchParams()
  return urlParamsToViewMode(params)
}

export function combineSearchParamsToQueryString(...searchParams: URLSearchParams[]) {
  const allParams = new URLSearchParams()
  searchParams.forEach((searchParam) => {
    for (const [key, val] of searchParam.entries()) {
      allParams.append(key, val)
    }
  })
  return allParams.toString()
}
